<template lang="pug">
  .homeItemDetalle
    .container
      .row
        .col-sm-3.product-cn
          picture.img-cn
            img(:src="checkEmptyImg(product.image_url)")
          h3 {{product.name}}
        .col-sm-3
          ul
            // li(v-if="product.supplier" class="prov-cn") #[translate Prov].: {{product.supplier.name}}
            li #[translate Código]: {{product.external_id}}
            li(v-if="product.quantity_by_packet") {{product.quantity_by_packet}} #[translate unidades por envase]
            li(v-if="product.packets_by_package") {{product.packets_by_package}} #[translate envases por paquete]
        .col-sm-2
          p.text-center {{entries.quantity}}
        .col-sm-2
          p.text-center {{fecha | moment("DD-MM-YYYY")}}
        .col-sm-2
          p.text-right(v-if="showPrice") {{priceTotal | format-money}} {{currency_symbol}}
</template>

<script>
import commonMixins from '@/mixins/commons.js'

export default {
  name: 'ValidarPedidoHomeItemDetalle',
  props: ['entries', 'billable', 'type', 'fecha', 'currency_symbol'],
  mixins: [commonMixins],
  data () {
    return {
      isFacturable: false,
      imgDefault: require('@/assets/img/no_disponible.png')
    }
  },
  computed: {
    product () {
      return this.entries.product
    },
    priceTotal () {
      // return this.entries.price * this.entries.quantity
      return this.entries.base
    }
  },
  created () {
    // console.log(`entries:`, this.entries)
  },
  methods: {
    checkEmptyImg (v) {
      return (v === null || v === '') ? require('@/assets/img/no_disponible.png') : v
    }
  }
}
</script>

<style lang="scss" scoped>
  .homeItemDetalle{
    padding:10px 0 14px;
    text-align: left;

    & > .container{
      position: relative;

      & > .row{
        display: flex;
        align-items: center;
      }
    }

    &:hover, &:focus{
      // @include box-shadow(all, 5px, rgba($black, 0.1) );
    }
  }

  .product-cn{
    position: initial;
    display: flex;
    align-items: center;
    padding-left: 100px;

  }

  .img-cn{
    position:absolute;
    top:0;
    bottom:0;
    left:6px;
    width: 78px;
    min-height:58px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    background-color: $white;
    @include roundAll(4);
    overflow: hidden;
    border: 1px solid #efefef;

    img{
      max-width: 100%;
      max-height: 54px;
      height:auto;
    }
  }

  h3{
    color:#1C2C40;
    font-size: 13px;
    text-transform: uppercase;
    margin:0;
    font-weight: $regular;
    // @include ellipsis();
  }

  ul{
    margin:0;
    padding:0;
    list-style: none;
  }

  li{
    font-size: 12px;
    color:#4D4F5C;
  }


</style>
